import React, { useEffect, useState } from 'react'
import OwnerSignupAndInvite from './Modal/OwnerSignupAndInvite'
import { loginWithCompany } from '../../services/public/public.service'
import { getDeviceInfo } from '../../helpers/helpers';
import { set } from 'react-hook-form';

export const SelectCompany = ({ requestId, companies, setComponentName }) => {
    const[deviceInfo, setDeviceInfo] = useState({});
    
    const handleLogin = async (item) => {
        const res = await loginWithCompany({ request_id: requestId, company_id: item ?.company_uuid, device_info: deviceInfo })
        if (res.data.status === 200) {
            localStorage.setItem('authToken', res.data.data.token)
            setTimeout(() => {
                // history.push('/learning-center');                        
                window.location.reload();
                // setLoading(false);
            }, 1000)
        }
    } 
    useEffect(() => {
        const load = async () => {
            handleLogin().then(res => {
                console.log(res, 'response')
            })
        }
        load()
    }, [])
    useEffect(() => {
        const load = async () => {
            getDeviceInfo().then(res => {
                console.log(res, 'response')
                setDeviceInfo(res)
            })
        }
        load()
    }, [])
    
    return (
        <div className='bg-white rounded-xl md:max-w-[560px] md:basis-[560px] pt-[72px] pb-[72px] px-6 grow-0 shrink-0 w-11/12 shadow-shadowcard'>
            <div className='w-[310px] !table mx-auto'>
                <p className='m-0 text-lg text-center font-medium'>
                    Select your Company
                </p>
                <div className='max-h-[60vh] overflow-y-auto overflow-x-hidden !px-2 !pb-2'>

                    {
                        companies.map((item, index) => (
                            <div className='w-[300px] rounded-lg shadow-boxshadow !p-3 !mt-6 hover:bg-blue-900/5' key={`${item.company_uuid}_${index}`} onClick={() => handleLogin(item)}>
                                <div className='text-blue-900 font-semibold bg-[#E5EFFF] rounded-lg w-12 h-12 flex items-center justify-center'>CN</div>
                                <div className='mt-2'>
                                    <p className='m-0 font-semibold'>{item?.company_name}</p>
                                    <p className='m-0 text-black700 text-xs'>{item?.owner_name} | {item?.owner_mobile}</p>
                                </div>
                            </div>
                        ))
                    }

                </div>
                <div className='cursor-pointer flex items-center justify-center !mt-4' onClick={() => {
                    setComponentName('ownerCheck');
                }}>
                    <span className='text-base text-blue-900 font-medium leading-9'>Create New Account?</span>
                </div>
                {/* <div className='w-[300px] rounded-lg shadow-boxshadow !p-3 !mt-5'>
                    <div className='text-blue-900 font-semibold bg-[#E5EFFF] rounded-lg w-12 h-12 flex items-center justify-center'>CN</div>
                    <div className='mt-2'>
                        <p className='m-0 font-semibold'>Company Name</p>
                        <p className='m-0 text-black700 text-xs'>$Owner_Name | +91-XXXXXXX6890</p>
                    </div>
                </div>
                <div className='w-[300px] rounded-lg shadow-boxshadow !p-3 !mt-5'>
                    <div className='text-blue-900 font-semibold bg-[#E5EFFF] rounded-lg w-12 h-12 flex items-center justify-center'>CN</div>
                    <div className='mt-2'>
                        <p className='m-0 font-semibold'>Company Name</p>
                        <p className='m-0 text-black700 text-xs'>$Owner_Name | +91-XXXXXXX6890</p>
                    </div>
                </div> */}
            </div>
            {/* <OwnerSignupAndInvite /> */}
        </div>
    )
}
